
export function getCookies(): Record<string, string> {
  return document.cookie.split('; ').reduce((dict, cookieRow) => {
    const [key, value] = cookieRow.split('=')
    dict[key] = value
    return dict
  }, {})
}

export function deleteCookie(name: string) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT`
}

/**
 * Taken from @snowplow/browser-tracker-core
 */
export function cookie(name: string, value?: string, ttl?: number, path?: string, domain?: string, samesite?: string, secure?: boolean) {
  if (arguments.length > 1) {
    const cookieValue = name +
          '=' +
          encodeURIComponent(value || '') +
          (ttl ? '; Expires=' + new Date(+new Date() + ttl * 1000).toUTCString() : '') +
          (path ? '; Path=' + path : '') +
          (domain ? '; Domain=' + domain : '') +
          (samesite ? '; SameSite=' + samesite : '') +
          (secure ? '; Secure' : '')
    return (document.cookie = cookieValue)
  }
  return decodeURIComponent((('; ' + document.cookie).split('; ' + name + '=')[1] || '').split(';')[0])
}
